__turbopack_context__.v({
  "bounce": "ContactForm-module-scss-module__taHw8a__bounce",
  "centerColumn": "ContactForm-module-scss-module__taHw8a__centerColumn",
  "checkboxWrapper": "ContactForm-module-scss-module__taHw8a__checkboxWrapper",
  "contactForm": "ContactForm-module-scss-module__taHw8a__contactForm",
  "contactInfo": "ContactForm-module-scss-module__taHw8a__contactInfo",
  "contactSoonMessage": "ContactForm-module-scss-module__taHw8a__contactSoonMessage",
  "fade-in": "ContactForm-module-scss-module__taHw8a__fade-in",
  "form": "ContactForm-module-scss-module__taHw8a__form",
  "formTitle": "ContactForm-module-scss-module__taHw8a__formTitle",
  "leftColumn": "ContactForm-module-scss-module__taHw8a__leftColumn",
  "open": "ContactForm-module-scss-module__taHw8a__open",
  "phoneLink": "ContactForm-module-scss-module__taHw8a__phoneLink",
  "pulse": "ContactForm-module-scss-module__taHw8a__pulse",
  "rightColumn": "ContactForm-module-scss-module__taHw8a__rightColumn",
  "rotated": "ContactForm-module-scss-module__taHw8a__rotated",
  "row": "ContactForm-module-scss-module__taHw8a__row",
  "selectChevron": "ContactForm-module-scss-module__taHw8a__selectChevron",
  "selectContainer": "ContactForm-module-scss-module__taHw8a__selectContainer",
  "selectDropdown": "ContactForm-module-scss-module__taHw8a__selectDropdown",
  "selectOption": "ContactForm-module-scss-module__taHw8a__selectOption",
  "selectPlaceholder": "ContactForm-module-scss-module__taHw8a__selectPlaceholder",
  "selectTrigger": "ContactForm-module-scss-module__taHw8a__selectTrigger",
  "selectValue": "ContactForm-module-scss-module__taHw8a__selectValue",
  "selected": "ContactForm-module-scss-module__taHw8a__selected",
  "slide-in": "ContactForm-module-scss-module__taHw8a__slide-in",
  "slide-left": "ContactForm-module-scss-module__taHw8a__slide-left",
  "slide-right": "ContactForm-module-scss-module__taHw8a__slide-right",
  "socials": "ContactForm-module-scss-module__taHw8a__socials",
  "successMessage": "ContactForm-module-scss-module__taHw8a__successMessage",
});
